<div class="modal-container">
    <h1 mat-dialog-title>Complete Your Profile</h1>
    <div mat-dialog-content>
        <p>Help us personalize your experience. Please complete your profile.</p>
        <form [formGroup]="form" class="profile-form" autocomplete="off">
            <mat-form-field appearance="outline">
                <mat-label>Company Name</mat-label>
                <mat-icon matPrefix>corporate_fare</mat-icon>
                <input matInput formControlName="companyName" required aria-label="Company Name" autocomplete="off" />
                <mat-error *ngIf="form.get('companyName')?.hasError('required')">
                    Company Name is required
                </mat-error>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline">
                <mat-label>Phone Number</mat-label>
                <mat-icon matPrefix>phone</mat-icon>
                <input matInput formControlName="phoneNumber" required aria-label="Phone Number" autocomplete="off" />
                <mat-error *ngIf="form.get('phoneNumber')?.hasError('required')">
                    Phone Number is required
                </mat-error>
                <mat-error *ngIf="form.get('phoneNumber')?.hasError('pattern')">
                    Please enter a valid phone number
                </mat-error>
            </mat-form-field> -->

            <mat-form-field appearance="outline">
                <mat-label>Team Size</mat-label>
                <mat-icon matPrefix>groups</mat-icon>
                <mat-select formControlName="teamSize" required aria-label="Team Size">
                    <mat-option *ngFor="let size of teamSizeOptions" [value]="size.value">
                        {{ size.label }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('teamSize')?.hasError('required')">
                    Team Size is required
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="onSkip()">Skip for now</button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!form.valid">Save and Continue</button>
    </div>
</div>